import React from "react";
import { withRouter } from "react-router-dom";
import classes from "./seeSolutions.module.css";
import { connect } from "react-redux";
import {
  fetchQuestions,
  clearQuestion,
  getQuestion,
  clearAssessmentResponse,
  getSelectedQuestion,
  getPreviousQuestion,
  getQuestionResponse,
  clearQuestionWithIndex,
} from "../../../../../store/actions/questions.action";
import { getAssessmentResponce } from "../../../../../store/actions/questionAnswer.action";
import { submitAssessment } from "../../../../../store/actions/questionAnswer.action";
import { readAssessment } from "../../../../../store/actions/assessment.action";
import ClearIcon from "@material-ui/icons/Clear";

import Question from "../Question";
import QuestionTrueFalse from "../QuestionTrueFalse";
import QuestionMultiSelect from "../QuestionMultiSelect";
import QuestionPictureType from "../QuestionPictureType";
import QuestionTextType from "../QuestionTextType";
import moment from "moment";

// Material UI
import { MButton, MIconButton, MPaginationButton } from "../../../../../UI";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LinearProgress from "@material-ui/core/LinearProgress";

// Icons
import CloseIcon from "@material-ui/icons/Close";
import AnsweredIcon from "../../../../../assets/img/assessmentLearnImages/answered.svg";
import NotAnsweredIcon from "../../../../../assets/img/assessmentLearnImages/notAnswered.svg";
import NotVisitedIcon from "../../../../../assets/img/assessmentLearnImages/notVisited.svg";
import MarkedReviewIcon from "../../../../../assets/img/assessmentLearnImages/markedReview.svg";
import MarkedAnsweredIcon from "../../../../../assets/img/assessmentLearnImages/markedAnswered.svg";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import { withTranslation } from "react-i18next";
import RollBackPopup from "../../../RollBack/RollBackPopup";

class AssignmentSolution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionnum: 0,
      counter: 0,
      submitDialogToggle: false,
      paginationDialogToggle: false,
    };
  }

  async componentWillMount() {
    let assessmentId = localStorage.getItem("_assessmentId");
    await this.props.fetchQuestions(assessmentId);
    let userId = localStorage.getItem("kneuraId");
    await this.props.getAssessmentResponce(assessmentId, userId);
  }

  async componentDidMount() {
    let assessmentId = localStorage.getItem("_assessmentId");
    await this.props.clearQuestion();
    await this.props.readAssessment(assessmentId);
    let userId = localStorage.getItem("kneuraId");
    await this.props.fetchQuestions(assessmentId);
    await this.props.getAssessmentResponce(assessmentId, userId);
    this.props.getSelectedQuestion(0);
  }

  gotoassessment = () => {
    this.props.history.goBack();
    this.props.history.goBack();
  };

  dialogOpenHandler = (dialogName) => (event) => {
    this.setState((prevState) => ({ ...prevState, [dialogName]: true }));
  };

  dialogCloseHandler = (dialogName) => (event) => {
    this.setState((prevState) => ({ ...prevState, [dialogName]: false }));
  };

  paginationButtonClickHandler = async () => {
    let assessmentId = localStorage.getItem("_assessmentId");
    let userId = localStorage.getItem("kneuraId");
    await this.props.getAssessmentResponce(assessmentId, userId);
    this.paginationQuestionLables();
    this.setState((prevState) => ({ paginationDialogToggle: true }));
  };

  getSelectedQuestion = (index) => async (event) => {
    await this.props.clearQuestionWithIndex();
    this.props.getSelectedQuestion(index);
    this.setState({ paginationDialogToggle: false });
  };

  paginationPreviousClickHandler = async () => {
    if (this.props.questionindex > 0) {
      await this.props.clearQuestionWithIndex();
      this.props.getSelectedQuestion(this.props.questionindex - 1);
    }
  };

  paginationNextClickHandler = async () => {
    if (
      this.props.questionindex + 1 <
      this.props.assessmentresponse.totalNumberOfQuestions
    ) {
      await this.props.clearQuestionWithIndex();
      this.props.getSelectedQuestion(this.props.questionindex + 1);
    }
  };

  goToResult = () => {
    this.props.history.replace("/test-submitted");
  };

  paginationQuestionLables = () => {
    const paginationLables = this.props.questionresponses.map((item, index) => {
      let classType = "";
      if (item.isVisited === false) {
        classType = classes.QuestionLabelNotVisited;
      }
      if (item.isVisited === true) {
        classType = classes.QuestionLabelNotAnswered;
      }
      if (item.isAnswered === true) {
        classType = classes.QuestionLabelAnswered;
      }
      if (item.isMarked === true) {
        classType = classes.QuestionLabelMarked;
      }
      if (item.isMarked === true && item.isAnswered === true) {
        classType = classes.QuestionLabelMarkedAnswered;
      }

      return (
        <div className={classType} onClick={this.getSelectedQuestion(index)}>
          {index + 1}
        </div>
      );
    });
    return paginationLables;
  };

  renderQuestionsHandler = () => {
    // this.props.question.type == "MULTIPLE_CHOICE" ? (
    //   <Question mode="test" />
    // ) : this.props.question.type == "TRUE_FALSE" ? (
    //   <QuestionTrueFalse mode="test" />
    // ) : this.props.question.type == "PICTURE_CHOICE" ? (
    //   <QuestionPictureType mode="test" />
    // ) : this.props.question.type == "MULTIPLE_SELECT" ? (
    //   <QuestionMultiSelect mode="test" />
    // ) : (
    //   <div>No Question To Display</div>
    switch (this.props.question.type) {
      case "MULTIPLE_CHOICE":
        return <Question mode="solution" />;
      case "TRUE_FALSE":
        return <QuestionTrueFalse mode="solution" />;
      case "PICTURE_CHOICE":
        return <QuestionPictureType mode="solution" />;
      case "MULTIPLE_SELECT":
        return <QuestionMultiSelect mode="solution" />;
      case "SUBJECTIVE":
        return <QuestionTextType mode="solution" />;
      default:
        return <div>No Question To Display</div>;
    }
  };

  render() {
    const { t } = this.props;
    const paginationQuestionLables = this.props.questions.map((item, index) => {
      return <div className={classes.QuestionLabelNotVisited}>{index + 1}</div>;
    });

    return (
      <>
        <RollBackPopup />
        <div className={classes.testgrid}>
          {/* Test Header */}
          <div className={classes.testheader}>
            <ClearIcon
              className={classes.pointercursor}
              style={{ color: "#5b697d", pointer: "cursor" }}
              onClick={this.gotoassessment}
            />
            <div className={classes.timertext}></div>
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                paddingRight: "1vw",
              }}
            >
              <MButton
                variant="contained"
                className={classes.SubmitBtn}
                onClick={this.goToResult}
              >
                {t("Result")}
              </MButton>
            </div>
          </div>
          {/* Test Body */}
          <div className={classes.testcontent}>
            {this.props.question ? (
              this.renderQuestionsHandler()
            ) : (
              <div>{t("No Question To Display")}</div>
            )}
          </div>
          {/* Test Footer */}

          <div
            style={{
              position: "absolute",
              bottom: "15px",
              right: 300,
            }}
          >
            <div
              style={{
                display: "inline-block",
                marginRight: "2vw",
                width: "15vw",
              }}
            >
              <p
                style={{
                  color: "rgba(52, 73, 94, 0.75)",
                  margin: "0 0 10px 0",
                }}
              >
                {" "}
                {this.props.assessmentresponse.answered} of{" "}
                {this.props.assessmentresponse.totalNumberOfQuestions}{" "}
                {t("answered")}
              </p>
              <LinearProgress
                variant="determinate"
                value={
                  (this.props.assessmentresponse.answered /
                    this.props.assessmentresponse.totalNumberOfQuestions) *
                  100
                }
                style={{ background: "rgba(52, 73, 94, 0.25)" }}
              />
            </div>
          </div>
          <div style={{ position: "absolute", bottom: "15px", right: 25 }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "1vh 1vw",
                background: "#fff",
                borderRadius: "1vh",
              }}
            >
              <MIconButton
                onClick={this.paginationPreviousClickHandler}
                size="small"
              >
                <ChevronLeftIcon />
              </MIconButton>
              <MPaginationButton onClick={this.paginationButtonClickHandler}>
                <span style={{ color: "rgba(52, 73, 94, 1)" }}>
                  {this.props.questionindex + 1} /{" "}
                  {this.props.assessmentresponse.totalNumberOfQuestions
                    ? this.props.assessmentresponse.totalNumberOfQuestions
                    : 1}
                </span>
              </MPaginationButton>
              <MIconButton
                onClick={this.paginationNextClickHandler}
                size="small"
              >
                <ChevronRightIcon />
              </MIconButton>
            </div>
          </div>

          {/* Pagination Dialog Starts */}
          {/* Pagination Dialog Starts */}
          <Dialog
            open={this.state.paginationDialogToggle}
            onClose={this.dialogCloseHandler("paginationDialogToggle")}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
            fullWidth
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{
                background: "rgba(100, 65, 164, 0.25)",
                display: "flex",
                flexDirection: "row-reverse",
                padding: "8px 24px 4px 24px",
              }}
            >
              <MIconButton
                onClick={this.dialogCloseHandler("paginationDialogToggle")}
              >
                <CloseIcon style={{ color: "#fff" }} />
              </MIconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                style={{ padding: "0 3vw" }}
              >
                {/* Icons List */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <p style={{ display: "inline", marginRight: "1vw" }}>
                    <img src={AnsweredIcon} alt="answeredIcon" />{" "}
                    {t("Answered")}
                  </p>
                  <p style={{ display: "inline", marginRight: "1vw" }}>
                    <img src={NotAnsweredIcon} alt="answeredIcon" />{" "}
                    {t("Not answered")}
                  </p>
                  <p style={{ display: "inline", marginRight: "1vw" }}>
                    <img src={NotVisitedIcon} alt="answeredIcon" />
                    {t("Not visited")}
                  </p>
                  <p style={{ display: "inline", marginRight: "1vw" }}>
                    <img src={MarkedReviewIcon} alt="answeredIcon" />{" "}
                    {t("Marked for review")}
                  </p>
                  <p style={{ display: "inline", marginRight: "1vw" }}>
                    <img src={MarkedAnsweredIcon} alt="answeredIcon" />{" "}
                    {t("Marked and answered")}
                  </p>
                </div>
                <hr style={{ border: "2px solid rgba(52, 73, 94, 0.25)" }} />
                <div>{this.paginationQuestionLables()}</div>
              </DialogContentText>
            </DialogContent>
          </Dialog>
          {/* Pagination Dialog Ends */}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    questions: state.questionsReducer.questions,
    question: state.questionsReducer.question,
    questionresponses: state.questionanswer.assessmentresponse.questionResponses
      ? state.questionanswer.assessmentresponse.questionResponses
      : [],
    assessmentresponse: state.questionanswer.assessmentresponse,
    assesmentresponseid: state.questionanswer.assessmentresponse.id,
    questionindex: state.questionsReducer.questionIndex,
    submitStatus: state.questionanswer.submitstatus,
    assessmentData: state.assessmentsReducer.assessmentdata,
  };
};

export default connect(mapStateToProps, {
  fetchQuestions,
  getQuestion,
  clearAssessmentResponse,
  getAssessmentResponce,
  submitAssessment,
  getSelectedQuestion,
  getPreviousQuestion,
  readAssessment,
  getQuestionResponse,
  clearQuestion,
  clearQuestionWithIndex,
})(withRouter(withTranslation()(AssignmentSolution)));
